import { localizePath } from '@/lib/localizePath';

/** Domaine canonique du site. */
export const SITE_DOMAIN = 'https://societerideau.fr';

export type SeoLang = 'fr' | 'en' | 'es' | 'it';

const SEO_LANGS: SeoLang[] = ['fr', 'en', 'es', 'it'];

export interface SeoAlternate {
  lang: SeoLang;
  href: string;
}

export interface SeoAlternates {
  /** URL absolue complète de la page pour la langue donnée. */
  canonicalForLang: (lang: string) => string;
  /** Liste des 4 alternates (fr, en, es, it) en URLs absolues. */
  alternates: SeoAlternate[];
  /** URL française absolue (x-default). */
  xDefault: string;
}

/**
 * Construit les URLs SEO multilingues pour une page donnée.
 * @param basePath chemin de base exprimé en français (ex: '/produits', '/').
 */
export const buildAlternates = (basePath: string): SeoAlternates => {
  const absoluteForLang = (lang: string): string => {
    const path = localizePath(basePath, lang);
    // localizePath renvoie '/' pour fr racine, '/en' pour en racine, etc.
    // On évite le double slash en concaténant simplement domaine + chemin.
    return `${SITE_DOMAIN}${path}`;
  };

  const alternates: SeoAlternate[] = SEO_LANGS.map((lang) => ({
    lang,
    href: absoluteForLang(lang),
  }));

  return {
    canonicalForLang: absoluteForLang,
    alternates,
    xDefault: absoluteForLang('fr'),
  };
};
